var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui-screen",
      style: {
        webkitTransform: _vm.transformation,
        transform: _vm.transformation,
        width: _vm.screenWidth
      },
      on: {
        contextmenu: function($event) {
          _vm.showContextMenu($event)
        }
      }
    },
    [
      _c("span", [
        _c("i", [
          _c("span", { staticClass: "display-1" }, [
            _vm._v(_vm._s(_vm.myScreen.label))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60b93a9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b93a9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Screen.vue
// module id = null
// module chunks = 